module.exports = __webpack_public_path__ + "static/media/Haymarket2019Logo.d5e7504b.svg";